import { getLabels } from '../labels';
import { decomposeDuration } from './decomposeDuration';
export const formatDurationParts = (totalMinutes) => {
    const durationLabels = getLabels().duration;
    const { months, days, hours, minutes } = decomposeDuration(totalMinutes);
    const parts = [];
    if (months > 0)
        parts.push(`${months}${durationLabels.month_shortcut}`);
    if (days > 0)
        parts.push(`${days}${durationLabels.day_shortcut}`);
    if (hours > 0)
        parts.push(`${hours}${durationLabels.hour_shortcut}`);
    if (minutes > 0 || parts.length === 0)
        parts.push(`${minutes}${durationLabels.minute_shortcut}`);
    return parts;
};
